<template>
  <div class="pb-3">
    <template
      v-if="
        (institution && !institution.kl_assessment) ||
        (user && user.group_names.includes('ESTUDIANTES'))
      "
    >
      <Page404></Page404>
    </template>
    <template v-else>
      <NavigationBreadcrumb
        v-if="section"
        :items="breadcrumb_items"
        :sticky="false"
        :sectionId="section.id"
        :showMatterProgram="true"
        :showNewFullGradingView="true"
        :showAssessmentStudents="true"
        :showEvaluatorEvaluations="true"
        :showAssessmentRangeSectionView="true"
        :showProfessorProgressionReportView="true"
        :showPdaView="true"
      ></NavigationBreadcrumb>
      <NavigationBreadcrumb
        v-else
        :items="breadcrumb_items"
        :sticky="false"
        :matterId="breadcrumbEgressProfileMatterId"
        :showEgressProfile="true"
        :showMatrix1="true"
        :showMatrix2="true"
        :showMatrix3="true"
        :showMatrix4="true"
        :showStudyPlan="true"
        :showCurricularMesh="true"
        :showMatterProgram="true"
        :showPlannification="true"
      ></NavigationBreadcrumb>
      <NewEvaluation
        :allows_crud="allows_crud"
        :evaluation_id="evaluation_id"
        :instrument_id="instrument_id"
        class="px-1"
      ></NewEvaluation>
    </template>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import matterLanguageMixin from "@/mixins/matterLanguageMixin";
export default {
  name: "NewEvaluationView",
  mixins: [matterLanguageMixin],
  components: {
    NewEvaluation: () => import("./NewEvaluation"),
    Page404: () => import("@/components/public/Page404"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {},
  data() {
    return {
      evaluation_id: Number(this.$route.params.evaluation_id),
      instrument_id: Number(this.$route.params.instrument_id),
      have_permission: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      evaluations: names.NEW_EVALUATIONS,
      sections: names.SECTIONS,
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      matters: names.MATTERS,
    }),
    evaluation() {
      return this.evaluations.find((x) => x.id == this.evaluation_id);
    },
    section() {
      if (this.evaluation && this.evaluation.scope == 1)
        return this.sections.find((x) => x.id == this.evaluation.scope_id);
      else return null;
    },
    matter() {
      if (this.evaluation && this.evaluation.scope == 3)
        return this.matters.find((x) => x.id == this.evaluation.scope_id);
      else return null;
    },
    egressProfileMatter() {
      if (this.evaluation && this.evaluation.scope == 2)
        return this.egress_profiles_matters.find(
          (x) => x.id == this.evaluation.scope_id
        );
      else return null;
    },
    allows_crud() {
      if (this.evaluation && this.evaluation.scope == 1)
        if (this.user && this.section && this.section.is_active) {
          const has_permission = this.$hasPermissions(
            "evaluations2.change_evaluation"
          );
          if (has_permission) return has_permission;
          else return false;
        } else return false;
      if (this.evaluation && this.evaluation.scope == 2)
        if (
          this.user &&
          this.egressProfileMatter &&
          !this.egressProfileMatter.is_closed &&
          this.have_permission &&
          this.have_permission.can_update == true
        ) {
          const has_permission = this.$hasPermissions(
            "evaluations2.change_evaluation"
          );
          if (has_permission) return has_permission;
          else return false;
        } else return false;
      if (this.evaluation && this.evaluation.scope == 3)
        if (
          this.user &&
          this.matter &&
          !this.matter.is_closed &&
          this.have_permission &&
          this.have_permission.can_update == true
        ) {
          const has_permission = this.$hasPermissions(
            "evaluations2.change_evaluation"
          );
          if (has_permission) return has_permission;
          else return false;
        } else return false;
      const has_permission = this.$hasPermissions();
      if (has_permission) return has_permission;
      else return false;
    },
    breadcrumb() {
      // Recuperar contexto del breadcrumb desde localStorage
      const context = localStorage.getItem("breadcrumb");
      return context ? JSON.parse(context) : {};
    },
    breadcrumbEgressProfileId() {
      return this.breadcrumb.egress_profile_id || null;
    },
    breadcrumbEgressProfileMatterId() {
      return this.breadcrumb.egress_profile_matter_id || null;
    },
    breadcrumbMatterId() {
      return this.breadcrumb.matter_id || null;
    },
    breadcrumb_items() {
      let breadcrumb = [];
      // 1. PRIMERO verificar si viene de sección
      if (this.section) {
        breadcrumb = [
          {
            text: this.$t("reusable.breadcrumb.home"),
            to: "/home",
          },
          ...(this.user && !this.user.group_names.includes("PROFESORES")
            ? [
                {
                  text: this.$getVisibleNames(
                    "manual.administrar_seccion",
                    true,
                    "Administrar Secciones"
                  ),
                  to: "/section/form",
                },
              ]
            : []),
          {
            text: this.$getVisibleNames(
              "evaluations2.evaluation",
              true,
              "Evaluaciones"
            ),
            dropdownOptions: [
              ...(this.institution &&
              this.institution.internal_use_id == "duoc.cl"
                ? ["showPdaView"]
                : []),
              "showNewFullGradingView",
              "showAssessmentStudents",
              "showEvaluatorEvaluations",
              "showAssessmentRangeSectionView",
              "showProfessorProgressionReportView",
            ],
          },
          {
            text: this.$getVisibleNames(
              "evaluations2.evaluation",
              false,
              "Evaluación"
            ),
          },
        ];
      }
      // 2. Luego verificar si viene de Matriz 2
      else if (
        this.breadcrumbEgressProfileId &&
        this.breadcrumbEgressProfileMatterId
      ) {
        breadcrumb = [
          {
            text: this.$t("reusable.breadcrumb.home"),
            to: "/home",
          },
          {
            text: this.$getVisibleNames("mesh.career", true, "Programas"),
            to: "/careers",
          },
          {
            text: this.$getVisibleNames("manual.matriz_2", false, "Matriz 2"),
            to: `/matrix2/form/${this.breadcrumbEgressProfileId}`,
            dropdownOptions: [
              "showEgressProfile",
              "showMatrix1",
              "showMatrix2",
              "showMatrix3",
              "showMatrix4",
              "showStudyPlan",
              "showCurricularMesh",
            ],
          },
          {
            text: this.$getVisibleNames(
              "manual.matter_program",
              false,
              "Programa de la Asignatura"
            ),
            to: `/matter/form/${this.breadcrumbEgressProfileMatterId}`,
            dropdownOptions: ["showPlannification", "showMatterProgram"],
          },
          {
            text: this.$getVisibleNames(
              "evaluations2.evaluation",
              false,
              "Evaluación"
            ),
          },
        ];
      }
      // 3. Finalmente verificar si viene de la vista de asignaturas
      else if (this.breadcrumbMatterId) {
        breadcrumb = [
          {
            text: this.$t("reusable.breadcrumb.home"),
            to: "/home",
          },
          {
            text: this.$getVisibleNames(
              "mesh.egressprofilematter",
              true,
              "Asignaturas"
            ),
            to: `/matter-list`,
          },
          {
            text: this.$getVisibleNames(
              "manual.matter_program",
              false,
              "Programa de la Asignatura"
            ),
            to: `/old-matter/form/${this.breadcrumbMatterId}`,
          },
          {
            text: this.$getVisibleNames(
              "evaluations2.evaluation",
              false,
              "Evaluación"
            ),
          },
        ];
      }
      return breadcrumb;
    },
  },
  methods: {
    evaluationPermission() {
      this.$restful
        .Get(
          `/evaluations2/user_evaluation_permissions/?evaluation_id=${this.evaluation.id}`
        )
        .then((response) => {
          this.have_permission = response;
        });
    },
  },
  mounted() {},
  watch: {
    matter: {
      immediate: true,
      handler(val) {
        if (!val) return;
        if (
          this.user &&
          this.user.student_card &&
          this.user.group_names.includes("ESTUDIANTES") &&
          this.user.student_card.egress_profile != val.egress_profile
        ) {
          this.$router.push({ name: "Page403" });
        }
        if (this.user && this.user.group_names.includes("PROFESORES")) {
          this.$restful
            .Get(`/mesh/fully_visible_professor_egress_profiles/`)
            .then((response) => {
              if (!response.includes(val.egress_profile)) {
                this.$router.push({ name: "Page403" });
              }
            });
        }
      },
    },
  },
  created() {
    this.$store.dispatch(names.FETCH_NEW_TEST_TYPES);
    this.$store.dispatch(names.FETCH_REDACTION_QUESTION_LENGTH_ANSWERS);
    this.$store.dispatch(names.FETCH_MULTIPLE_QUESTION_SCORE_TYPES);
    this.$store.dispatch(names.FETCH_RUBRIC_PRESETS);
    this.$store.dispatch(names.FETCH_RUBRIC_PRESET_UNITS);
    this.$store.dispatch(names.FETCH_NEW_FILLING_QUESTION_SUB_TYPES);
    this.$store.dispatch(names.FETCH_TAXONOMIES);

    this.$store
      .dispatch(names.FETCH_NEW_EVALUATION, this.evaluation_id)
      .then((response) => {
        this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, true);
        this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
          visible_intelligence_options: [7],
        });
        if (response.scope == 1 && response.scope_id != null) {
          this.$store
            .dispatch(names.FETCH_SECTION, response.scope_id)
            .then((section) => {
              this.$store
                .dispatch(
                  names.FETCH_EGRESS_PROFILE_MATTER,
                  section.egress_profile_matter
                )
                .then((egress_profile_matter) => {
                  this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
                    matter_id: egress_profile_matter.matter,
                    show_message_evaluation_view: true,
                    extra_context: this.$t(
                      "evaluations.newEvaluations.forTheEvaluation"
                    ),
                    intelligence_option: 7,
                  });
                });
            });
        }
        if (response.scope == 2 && response.scope_id != null) {
          this.$store
            .dispatch(names.FETCH_EGRESS_PROFILE_MATTER, response.scope_id)
            .then((egress_profile_matter) => {
              this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
                matter_id: egress_profile_matter.matter,
                show_message_evaluation_view: true,
                extra_context: this.$t(
                  "evaluations.newEvaluations.forTheEvaluation"
                ),
                intelligence_option: 7,
              });
            });
        }
        if (response.scope == 3 && response.scope_id != null) {
          this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
            matter_id: response.scope_id,
            show_message_evaluation_view: true,
            intelligence_option: 7,
          });
        }
        if (response.scope == 2 || response.scope == 3) {
          this.evaluationPermission();
        }
        this.applyLanguageForEvaluation(response);
      });
  },

  beforeDestroy() {
    this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, false);
    this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
    this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);
  },
};
</script>

<style scoped>
</style>
